/* eslint-disable max-classes-per-file */

import {
  MainTableFilterModel,
  PrintReportFilterModel,
} from 'src/app/shared/models/main-table-filter.model';
import { IProductImportRequest } from '../models/product-import.model';
import { IProductRequest, ITransferProductRequest } from '../models/product.model';
import { IUseProduct } from '../models/use-product.model';

export class LoadProducts {
  static readonly type = '[Products] Load Products via Service';
  constructor(
    public filter?: MainTableFilterModel,
    public menuId?: string
  ) {}
}

export class LoadAllProducts {
  static readonly type = '[Products] Load All Products via Service';
  constructor(
    public excludeAttachedToMaintenanceJobId?: string,
    public excludeAttachedToComponentId?: string
  ) {}
}

export class LoadProductById {
  static readonly type = '[Products] Load Product By Id via Service';
  constructor(public id: string) {}
}

export class CreateProduct {
  static readonly type = '[Products] Create Product';
  constructor(
    public product: IProductRequest,
    public redirect = true
  ) {}
}

export class UpdateProduct {
  static readonly type = '[Products] Update Product';
  constructor(
    public product: IProductRequest,
    public referrerType?: string,
    public referrerId?: string,
    public referrerParentId?: string
  ) {}
}

export class DeleteProduct {
  static readonly type = '[Products] Delete Product';
  constructor(
    public productId: string,
    public menuId: string,
    public referrerType?: string,
    public referrerId?: string,
    public referrerParentId?: string
  ) {}
}

export class UseProduct {
  static readonly type = '[Products] Use Product';
  constructor(public product: IUseProduct) {}
}

export class AddToStock {
  static readonly type = '[Products] Add to Stock';
  constructor(
    public product: IUseProduct,
    public redirect = true
  ) {}
}

export class AdjustStock {
  static readonly type = '[Products] Adjust Stock';
  constructor(public product: IUseProduct) {}
}

export class LoadProductStock {
  static readonly type = '[Products] Get Product Stock';
  constructor(public productId: string) {}
}

export class ClearProductsByMenu {
  static readonly type = '[Products] Clear products by menu';
  constructor() {}
}

export class PrintProductsReport {
  static readonly type = '[Products] Print Report';
  constructor(
    public filter?: PrintReportFilterModel,
    public menuId?: string
  ) {}
}

export class ImportStorageProducts {
  static readonly type = '[Products] Import Storage Products';
  constructor(public productImport: IProductImportRequest) {}
}

export class ClearCurrentProduct {
  static readonly type = '[Products] Clear Current Product';
  constructor() {}
}

export class LoadMatchingProducts {
  static readonly type = '[Products] Load Matching Products';
  constructor(
    public sourceStorageProductId: string,
    public targetDepartmentId: string,
    public sourceDepartmentId: string
  ) {}
}

export class TransferProduct {
  static readonly type = '[Products] Transfer Product';
  constructor(
    public transferRequest: ITransferProductRequest,
    public sourceDepartmentId: string,
    public refreshList = true
  ) {}
}
